module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.withToolbar) ? _c('div', [_c('v-btn', {
    staticClass: "indigo--text",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.activeComponent = "Reschedule"
      }
    }
  }, [_c('v-icon', [_vm._v("today")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "indigo--text",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.activeComponent = "InvoiceDetails"
      }
    }
  }, [_c('v-icon', [_vm._v("account_balance_wallet")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "indigo--text",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.activeComponent = "Notes"
      }
    }
  }, [_c('v-icon', [_vm._v("note")])], 1)], 1) : _vm._e(), _vm._v(" "), _c(_vm.activeComponent, {
    tag: "component",
    attrs: {
      "stand-alone": _vm.standAlone,
      "with-time-selector": _vm.withTimeSelector,
      "with-back": false,
      "appointment": _vm.appointment,
      "value": _vm.appointment,
      "touch": _vm.touch
    },
    on: {
      "note:save": function($event) {
        return _vm.$emit("close")
      },
      "appointmentcancelled": function($event) {
        return _vm.$emit("close")
      },
      "appointmentrescheduled": function($event) {
        return _vm.$emit("close")
      },
      "close": function($event) {
        return _vm.$emit("close")
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9966a72","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalDialogContainer.vue
// module id = 1530
// module chunks = 9